const app = angular.module('msi.shipments.shipmentController', []);

function ShipmentControllerFactory(orderService, itemOrchestrator, OneTimeDifferences, shippingService, $filter, paymentService) {
  class ShipmentController {
    refresh() {
      return orderService.get(this.shipment.publicId).then((order) => {
        this.shipment = order;
        return this.refreshItems();
      });
    }

    constructor() {
      this.$filter = $filter;
      this.billingConfig = paymentService.getPaymentConfig();
      this.shippingConfig = shippingService.getShippingConfig();
      this.currencySymbol = this.$filter('translate')('CURRENCY_SYMBOL');
    }

    refreshItems() {
      return itemOrchestrator.getItemsWithProductsForShipment(this.shipment.publicId).then((items) => {
        // TODO Put this in a domain
        this.shipment.oneTimeDifferences = new OneTimeDifferences();
        this.shipment.items = items;
      });
    }

    $postLink() {
      this.refresh();
    }
  }

  return new ShipmentController();
}

ShipmentControllerFactory.$inject = ['ogsdk.orderService', 'itemOrchestrator', 'OneTimeDifferences', 'shippingService', '$filter', 'paymentService'];

app.controller('ShipmentController', ShipmentControllerFactory);

module.exports = app.name;
